<template>
  <div class="interview-footer__container">
    <div v-if="options.length > 0" class="interview-footer__options-container">
      <button
        v-for="{ id, displayText, selected } in options"
        :key="id"
        :class="{
          'interview-footer__option': true,
          'interview-footer__option--selected': selected,
          'interview-footer__option--rtl': isRtl,
        }"
        :data-test-id="`InterviewFooter_SpecialOption-${id}`"
        role="option"
        :aria-selected="selected"
        @click="() => $emit('toggleOption', id)"
      >
        {{ displayText }}
      </button>
    </div>
    <button
      class="interview-footer__continue-button"
      :disabled="!canSubmit || isLoading"
      data-test-id="InterviewFooter_ContinueButton"
      @click="$emit('continue')"
    >
      <div v-if="isLoading" class="interview-footer__continue-button-spinner" />
      <p v-else>
        {{ submitText }}
      </p>
    </button>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import { isRtlLocale } from '../../../intl'

export default defineComponent({
  props: {
    options: {
      type: Array as PropType<{ id: string; displayText: string; selected: boolean }[]>,
      default: () => [],
    },
    submitText: {
      type: String,
      required: true,
    },
    canSubmit: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      required: true,
      type: Boolean,
    },
  },
  emits: {
    continue: () => true,
    toggleOption: (_optionId: string) => true,
  },

  setup() {
    return { isRtl: isRtlLocale() }
  },
})
</script>
<style lang="postcss">
.interview-footer {
  &__container {
    display: flex;
    flex-direction: column;
  }
  &__options-container {
    display: flex;
    justify-content: space-between;
  }
  &__input--hidden {
    display: none;
  }
  &__option {
    color: var(--color-text-button);
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 100%;
    background-color: white;
    transition: background 0.12s;
    border: 1px solid var(--color-blue-grey);
    border-right: 0;
    &--selected {
      background-color: var(--color-selected);
      border-top-color: var(--color-selected);
      border-bottom-color: var(--color-selected);
      color: white;
    }
    &:first-child {
      border-left: 0;
    }

    &--rtl {
      &:first-child {
        border-left: 1px solid var(--color-blue-grey);
        border-right: 0;
      }

      &:last-child {
        border-left: 0;
      }
    }
  }
  &__continue-button {
    padding: 1rem;
    background-color: var(--color-success);
    color: white;
    border: 0;
    cursor: pointer;
    &:disabled {
      background-color: var(--color-blue-grey);
      color: var(--color-disabled-text);
    }
  }
  &__continue-button-spinner {
    width: 16px;
    height: 16px;
    margin: auto;
    border-radius: 100%;
    border: white 2px solid;
    border-right: transparent 2px solid;
    animation: spin 0.5s infinite ease-in-out;
  }
}
</style>
